import { TButtonInstance } from 'widgets/global/Button';

/**
 * @param Widget Base widget for extending
 * @returns RefinementPriceRange widget
 */
export default function (RefinementPriceRange: ReturnType<typeof import('priceslider/search/RefinementPriceRange').default>) {
    /**
     * @category widgets
     * @subcategory search
     * @class CoreRefinementPriceRange
     * @augments RefinementPriceRange
     * @classdesc
     * Parent component that link together 2 steppers (input numbers) and multi thumb
     * slider. Could be used with or without slider.
     *
     * @property {string} data-widget - Widget name `refinementPriceRange`
     * @property {number} data-price-from - price selected range from
     * @property {number} data-price-to - price selected range to
     * @property {number} data-price-min - price sub range start
     * @property {number} data-price-max - price sub range end
     *
     * @example
     * <div
     *     class="b-refinement_range"
     *     data-widget="refinementPriceRange"
     *     data-price-from="${priceFrom}"
     *     data-price-to="${priceTo}"
     *     data-price-min="${priceMin}"
     *     data-price-max="${priceMax}"
     *     data-forward-to-parent="updateView"
     * >
     *     <div class="b-refinement_range-group">
     *         <div
     *             class="b-refinement_range-field"
     *             data-widget="inputStepper"
     *             data-update-delay="0"
     *             data-widget-event-change="onChange"
     *             data-id="priceFrom"
     *         >
     *         ...
     *         </div>
     *
     *         <div class="b-refinement_range-dash">
     *             &mdash;
     *         </div>
     *
     *         <div
     *             class="b-refinement_range-field"
     *             data-widget="inputStepper"
     *             data-widget-event-change="onChange"
     *             data-update-delay="0"
     *             data-id="priceTo"
     *         >
     *         ...
     *         </div>
     *     </div>
     *
     *     <svg
     *         data-widget="multiThumbSlider"
     *         data-id="multiThumbSlider"
     *     >
     *     ...
     *     </svg>
     *
     *     <a
     *         href="${refinement.searchUrl}"
     *         data-id="applyBtn"
     *         data-widget="button"
     *         data-widget-event-click="updateView"
     *         data-event-click.prevent="handleClick"
     *         data-href="${refinement.searchUrl}"
     *     >
     *         Apply
     *     </a>
     * </div>
     */
    class CoreRefinementPriceRange extends RefinementPriceRange {
        /**
         * @description Update submit button href
         * @emits "update"
         */
        updateActionsData() {
            this.getById<TButtonInstance, void>('applyBtn', applyBtn => {
                applyBtn.ref('self').data('analyticsRefinementLabel', `price~${this.min}-${this.max}`);
            });

            super.updateActionsData();
        }
    }

    return CoreRefinementPriceRange;
}
